import React from 'react';
import './guide_logo.scss';
import { t } from 'services/translation';

export default class CoverGuideLogo extends React.Component {
  static displayName = 'CoverGuideLogo';

  render() {
    return (
      <div className="CoverGuideLogo">
        <img src={this.props.picture} className="guide-logo" />
        <span className="text">
          <span className="title">
            <span className="name">{this.props.tourName}</span>
          </span>
          <span className="guide">
            {t('WITH')} {this.props.guideName}
          </span>
        </span>
      </div>
    );
  }
}
